export const IValidateUseCaseType = Symbol('IValidateUseCase');
